import * as components from './components'

export default [
  {
    path: '/institution/:uuid/summary',
    component: components.InstitutionSummary,
    name: 'institutionSummary',
    props: true
  },
  {
    path: '/institution/:uuid/details',
    component: components.InstitutionDetails,
    name: 'institutionDetails',
    props: true
  },
  {
    path: '/institution/switch',
    component: components.InstitutionSwitch,
    name: 'InstitutionSwitch',
    props: true
  },
  {
    path: '/institution/:uuid/child',
    component: components.ChildInstitutionSwitch,
    name: 'ChildInstitutionSwitch',
    props: true
  },
  {
    path: '/institution/:uuid/setting/:configName',
    component: components.InstitutionSettings,
    name: 'InstitutionSettings',
    props: true
  },
  {
    path: '/institution/:uuid/websitewidget',
    component: components.InstitutionWidgets,
    name: 'InstitutionWidgets',
    props: true
  },
  {
    path: '/institution/:uuid/signupconfig',
    component: components.LandingPages,
    name: 'LandingPages',
    props: true
  },
  {
    path: '/institution/:uuid/institutionemailcampaign',
    component: components.InstitutionEmailCampaign,
    name: 'InstitutionEmailCampaign',
    props: true
  },
  {
    path: '/institution/:uuid/edit',
    component: components.EditInstitutionDetails,
    name: 'editInstitutionDetails',
    props: true
  },
  {
    path: '/institution/:uuid/package/:packageId/edit',
    component: components.EditInstitutionPackage,
    name: 'editInstitutionPackage',
    props: true
  },
  {
    path: '/institution/:uuid/reports',
    component: components.InstitutionReports,
    name: 'institutionReports',
    props: true
  },
  {
    path: '/institution/:uuid/otherEntities',
    component: components.InstitutionEntities,
    name: 'institutionEntities',
    props: true
  },
  {
    path: '/institution/:uuid/packages',
    component: components.InstitutionPackages,
    name: 'institutionPackages',
    props: true
  },
  {
    path: '/institution/:uuid/packages/admin',
    component: components.AdministerInstitutionPackages,
    name: 'administerInstitutionPackages',
    props: true
  },
  {
    path: '/institution/:uuid/configuration',
    component: components.InstitutionConfiguration,
    name: 'institutionConfiguration',
    props: true
  },
  {
    path: '/institution/:uuid/configuration/edit',
    component: components.EditInstitutionConfiguration,
    name: 'editInstitutionConfiguration',
    props: true
  },
  {
    path: '/institution/list',
    component: components.InstitutionList,
    name: 'institutionList',
    props: true
  },
  {
    path: '/institution/create',
    component: components.CreateInstitution,
    name: 'createInstitution',
    props: true
  },
  {
    path: '/institution/:uuid/exploreWidget',
    component: components.InstitutionWidgetDetail,
    name: 'institutionWidgetDetail',
    props: true
  },
  {
    path: '/institution/:uuid/courseReportingWidget',
    component: components.InstitutionCourseWidgetDetail,
    name: 'institutionCourseWidgetDetail',
    props: true
  },
  {
    path: '/institution/:uuid/apiConfig',
    component: components.InstitutionApiConfiguration,
    name: 'institutionApiConfiguration',
    props: true
  },
  {
    path: '/institution/:uuid/employerMapping',
    component: components.InstitutionEmployerMapping,
    name: 'institutionEmployerMapping',
    props: true
  },
  {
    path: '/institution/:uuid/selfRegistrationLinkConfig',
    component: components.SelfRegistrationLinkConfiguration,
    name: 'selfRegistrationLinkConfig',
    props: true
  },
  {
    path: '/institution/:uuid/emailcampaign',
    component: components.EmailCampaignList,
    name: 'emailCampaignList',
    props: true
  },
  {
    path: '/institution/:uuid/emailcampaign/create',
    component: components.EmailCampaignCreate,
    name: 'emailCampaignCreate',
    props: true
  },
  {
    path: '/institution/pre-curated/list',
    component: components.PreCuratedInstitutionList,
    name: 'preCuratedInstitutionList',
    props: true
  },
  {
    path: '/institution/pre-curated/upload',
    component: components.PreCuratedInstitutionUpload,
    name: 'preCuratedInstitutionUpload',
    props: true
  },
  {
    path: '/institution/paymentgateway',
    component: components.InstitutionPaymentGateway,
    name: 'institutionPaymentGateway',
    props: true
  },
  {
    path: '/institution/pricingPlans',
    component: components.InstitutionPricingPlans,
    name: 'institutionPricingPlans',
    props: true
  },
  {
    path: '/institution/couponCodes',
    component: components.InstitutionCouponCodes,
    name: 'institutionCouponCodes',
    props: true
  },
  {
    path: '/institution/transactions',
    component: components.InstitutionTransactions,
    name: 'institutionTransactions',
    props: true
  },
  {
    path: '/institution/:uuid/assignAssociated',
    component: components.AssignAssociatedInstitution,
    name: 'assignAssociatedInstitutions',
    props: true
  },
  {
    path: '/institution/:uuid/configureKnowledgeCheckDecsription',
    component: components.InstitutionKnowledgeCheckDescription,
    name: 'institutionKnowledgeCheckDescription',
    props: true
  }
]



// WEBPACK FOOTER //
// ./src/app/institution/routes.js